/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateNotesDto } from '../models/work-update-notes-dto';
import { WorkUserV2 } from '../models/work-user-v-2';

@Injectable({ providedIn: 'root' })
export class WorkUsersMeV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usersMeV2ControllerGetUserDetails()` */
  static readonly UsersMeV2ControllerGetUserDetailsPath = '/v2/users-me';

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersMeV2ControllerGetUserDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersMeV2ControllerGetUserDetails$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUserV2>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersMeV2Service.UsersMeV2ControllerGetUserDetailsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUserV2>;
      })
    );
  }

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersMeV2ControllerGetUserDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersMeV2ControllerGetUserDetails(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkUserV2> {
    return this.usersMeV2ControllerGetUserDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUserV2>): WorkUserV2 => r.body)
    );
  }

  /** Path part for operation `usersMeV2ControllerUpdateNotes()` */
  static readonly UsersMeV2ControllerUpdateNotesPath = '/v2/users-me/notes';

  /**
   * Required permissions: users:update, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersMeV2ControllerUpdateNotes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersMeV2ControllerUpdateNotes$Response(
    params: {
      body: WorkUpdateNotesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUsersMeV2Service.UsersMeV2ControllerUpdateNotesPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: users:update, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersMeV2ControllerUpdateNotes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersMeV2ControllerUpdateNotes(
    params: {
      body: WorkUpdateNotesDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.usersMeV2ControllerUpdateNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
